import { sendLaunchDarklyMetric } from './launchdarkly-track';

/**
 * Tracks clicks on homepage app install store badges.
 */
(function () {
  const LINK_SELECTOR =
    '[data-homepage-student-living-app] a[data-app-install-store]';
  const EVENT_NAME = 'app_install_cta_clicked';

  document.addEventListener(
    'click',
    function (event) {
      if (
        !window.config ||
        !window.config.launchDarkly ||
        !window.config.launchDarkly.enabled
      ) {
        return;
      }

      if (!(event.target instanceof Element)) {
        return;
      }

      const link = event.target.closest(LINK_SELECTOR);

      if (!link) {
        return;
      }

      const store = link.dataset.appInstallStore || null;

      sendLaunchDarklyMetric(EVENT_NAME, {
        store,
      });
    },
    true
  );
})();
